import classnames from "classnames";
import styles from "../styles/preview.module.scss";
import { useToggleFavorite } from "services/users";
import { ToggleButton } from "../StoryPreview";
import PropTypes from "prop-types";

function FavoriteButton({ story }) {
  const [isFavorite, toggleFavorite] = useToggleFavorite(story._id);

  return (
    <ToggleButton
      className={classnames({ [styles.favorite]: isFavorite })}
      icon={isFavorite ? "favorite" : "favorite_border"}
      label="Favorito"
      onClick={toggleFavorite}
    />
  );
}

FavoriteButton.propTypes = {
  story: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    isOwner: PropTypes.bool,
  }).isRequired,
  styles: PropTypes.object.isRequired,
};

export default FavoriteButton;
